import { createBaseQueries, IsProdMode } from '@gyandiksha/shared-ui';

const API_URL = (IsProdMode) ? import.meta.env.VITE_PROD_API_URL : import.meta.env.VITE_LOCAL_API_URL

export const { baseQuery, defaultBaseQuery, customFetchBase } = createBaseQueries({
    apiUrl: API_URL,
});